import { createTheme } from '@material-ui/core/styles';
import { Pagination } from '@material-ui/lab';
import { ENGINE_METHOD_NONE } from 'constants';



const defaultTheme = createTheme();

const VitalsMDTheme = createTheme({
    palette: {
        primary: {
            main: '#00AAD1', /*TEAL*/
            light: '#ff0000',/*RED*/
            dark: '#038365' /*GREEN*/
        },
        secondary: {
            main: '#60C0AB' /*LIGHT GREEN*/
        }
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                a: {
                    color: 'rgba(0, 0, 0, .87)',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    '&:hover': {
                        color: '#00AAD1',
                        textDecoration: 'none'
                    }
                },
                body: {
                    backgroundColor: '#ffffff'
                },
            },
        },
        MuiTypography: {
            caption: {
                color: 'rgba(0,0,0,0.4)',
                lineHeight: 1
            },
            h5: {
                color: '#000'
            },
            h6: {
                fontWeight: 500 /*main titles */
            },
            body1: {
                fontSize: '0.875rem'
            },
            body2: {
                fontWeight: 300,
                color: '#2C3137' /*DARK GRAY BODY and TITLES*/
            },
            overline: {
                fontSize: '0.875rem',
                fontWeight: 300
            },
            smalldate: {
                fontSize: '0.175rem',
                fontWeight: 300
            }
        },
        MuiContainer: {
            root: {
                [defaultTheme.breakpoints.up('sm')]: {
                    paddingLeft: '24px',
                    paddingRight: '24px'
                },
                paddingLeft: '16px',
                paddingRight: '16px'
            }
        },
        MuiAppBar: {
            colorPrimary: {
                color: '#fff',
                backgroundColor: '#2C3137',
                boxShadow: 'none',
                borderBottom: '0'
            }
        },
        MuiDrawer: {
            paper: {
                backgroundColor: '#2C3137'
            }
        },
        MuiIconButton: {
            root: {

            }
        },

        MuiListItemText: {
            root: {
                color: 'white',
                opacity: 0.4,
                fill: 'white',
                '&:hover': {
                    color: 'white',
                    opacity: 1,
                    fill: 'white'
                }
            }
        },
        MuiListItemIcon: {
            root: {
                color: 'white',
                opacity: 0.4,
                fill: 'white',
                '&:hover': {
                    color: 'white',
                    opacity: 1,
                    fill: 'white'
                }
            }
        },
        MuiBottomNavigation: {
            root: {
                position: 'fixed',
                bottom: 0,
                width: '100%',
                marginTop: '56px',
                backgroundColor: '#2C3137'
            }
        },
        MuiBottomNavigationAction: {
            root: {
                color: 'white',
                opacity: 0.4,
                '&:hover': {
                    color: 'white',
                    opacity: 1
                },
                '&$selected': {
                    color: 'white',
                    opacity: 1
                }
            },
            label: {
                '&$selected': {
                    fontSize: '0.75rem'
                }
            }
        },
        MuiBadge: {
            badge: {
                backgroundColor: '#EE3526',
                color: 'white'
            }
        },
        MuiTab: {
            wrapper: {
                letterSpacing: '1px'
            }
        },
        MuiTabs: {
            root: {
                backgroundColor: 'white'
            }
        },
        MuiButton: {
            contained: {
                color: 'white',
                backgroundColor: '#00AAD1',
                '&:hover': {
                    backgroundColor: '#00CFFF'
                }
            },
            text: {
                color: 'white',
                '&:hover': {
                    backgroundColor: 'rgba(0, 170, 209, 0.04)'
                }
            }
        },

        MuiInput: {
            underline: {
                '&:hover:not($disabled):before': {
                    borderBottom: '2px solid #00AAD1'
                }
            }
        },
        MuiOutlinedInput: {
            root: {
                backgroundColor: 'white',
                borderColor: 'rgba(0,0,0,0.4)',
                '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
                    borderColor: '#00AAD1',
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        borderColor: 'rgba(0, 0, 0, 0.23)',
                    },
                },
                '&$focused $notchedOutline': {
                    borderColor: '#00AAD1',
                }
            }
        },
        MuiFormControl: {
            root: {
                minWidth: '100%',
                flexDirection: 'column'
            }
        },
        MuiFormLabel: {
            root: {
                '&$focused': {
                    color: '#00AAD1'
                }
            },
            asterisk: {
                color: 'transparent'
            }
        },
        MUIDataTableSelectCell: {
            root: {
                backgroundColor: "transparent",
            },
            headerCell: {
                backgroundColor: "transparent",
            }
        },

        MuiTableCell: {
            root: {
                padding: '16px'
                }
            },

        MUIDataTableHeadCell: {
            fixedHeader: {
                backgroundColor: "transparent",
            }
        },
        MUIDataTable: {
            paper: {
                backgroundColor: "white",
                borderRadius: '0',
                boxShadow: 'none',
                transition: 'none'
            }
        },
        MUIDataTableSearch: {
            main: {
                display: 'inline-flex',
                padding: '8px 16px'
            }
        }
    }
});


export default VitalsMDTheme;